import { userHasSomeRights } from "../../../functions/userRights";
import i18n from "../../../functions/i18next";
import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import uniqid from "uniqid";

export default {
  props: {
    itemData: {
      type: Object,
    },
    zIndex: Number,
  },
  data() {
    return {
      id: uniqid(),
      openDeleteMenu: false,
      beingDeleted: false,
      openActions: true,
      actions: [],
    };
  },
  created() {
    this.setActions();

    EventBus.$on(`item-actions--closed`, (parentId) => {
      this.openActions = false;
    });
    EventBus.$on(`item-actions--open`, (parentId) => {
      this.openActions = true;
    });

    EventBus.$on("closeallactions", () => {
      this.openActions = true;
    });
  },
  methods: {
    handleCheckCanGo(e) {
      e.preventDefault();
      if (!this.beingDeleted) {
        this.$router.push(
          this.itemData.myspace == 1
            ? `/${this.$store.state.company}/myspace`
            : `/${this.$store.state.company}/home/expanded/${this.itemData.id}`
        );
      }
    },
    setActions() {
      this.actions = [
        {
          name: i18n.t("common.edit"),
          icon: "edit",
          rights: ["edit_spaces"],
          func: () => {
            setTimeout(() => {
              EventBus.$emit("editspace", this.itemData.id);
              EventBus.$emit(`right-sidebar-show`, {
                id: "edit-space",
                data: this.itemData.id,
              });
            }, 100);
          },
        },
        {
          name: i18n.t("common.delete"),
          icon: "delete--alt",
          rights: ["delete_spaces"],
          func: () => {
            this.setOpenDeleteMenu(false, true);
          },
        },
      ];
    },
    checkCanEditSpaces() {
      return userHasSomeRights(["edit_spaces", "delete_spaces"], this);
    },

    setOpenDeleteMenu(e, status) {
      if (e) {
        e.preventDefault();
      }

      this.openDeleteMenu = status;
    },
    deleteSpace(e) {
      e.preventDefault();

      this.setOpenDeleteMenu(false, false);
      this.beingDeleted = true;

      const formData = new FormData();
      formData.append("folder", this.itemData.id);

      this.$axios
        .post(baseUrl + "/folderdelete", formData)
        .then((r) => {
          EventBus.$emit("roots");
          EventBus.$emit(`tree-overview-reset`);
        })
        .catch((e) => {
          EventBus.$emit(`snackbar--add`, {
            title: i18n.t("common.something_went_wrong"),
            icon: "error--round",
            color: "#df3535",
            title: i18n.t("common.upload_error"),
            timeout: 3000,
          });
        });
    },
  },
};
